import { useState } from "react";

import { getCaseId, getClientId } from "@/Utils/helper";

import HintModal from "../common/hint-modal";
import NavFirmTemplateSettingsTab from "../common/nav-firm-template-settings-tab";

import useGetESignatureCaseTypes from "./hooks/useGetESignatureCaseTypes";
import useGetESignatureTemplates from "./hooks/useGetESignatureTemplates";
import ESignatureTemplates from "./tabs/e-signature-templates";
import UploadESignatureTemplate from "./tabs/upload-e-signature-template";

import "../letter-templates/tabs/UploadLetterTemplates.css";
import "./styles.css";

const TEMPLATE_TAB = "esign-templates";
const UPLOAD_TAB = "esign-upload";

const ESignature = () => {
  const [activeTab, setActiveTab] = useState(TEMPLATE_TAB);
  const [showHints, setShowHints] = useState(false);
  const {
    templates,
    loading: templatesLoading,
    error: templatesError,
    refetch: refetchTemplates,
  } = useGetESignatureTemplates();
  const {
    caseTypesByCategory,
    loading: caseTypesLoading,
    error: caseTypesError,
    refetch: refetchCaseTypes,
  } = useGetESignatureCaseTypes();

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
  };

  const sidebarItems = [
    {
      id: TEMPLATE_TAB,
      label: "E-Signature Templates",
      onClick: () => handleTabChange(TEMPLATE_TAB),
      background:
        activeTab === TEMPLATE_TAB ? "var(--primary) !important" : "var(--primary-5) !important",
      color: activeTab === TEMPLATE_TAB ? "#fff !important" : "#777 !important",
      rightHand: true,
    },
    {
      id: UPLOAD_TAB,
      label: "Upload E-Signature Template",
      onClick: () => handleTabChange(UPLOAD_TAB),
      background:
        activeTab === UPLOAD_TAB ? "var(--primary) !important" : "var(--primary-5) !important",
      color: activeTab === UPLOAD_TAB ? "#fff !important" : "#777 !important",
      rightHand: true,
    },
  ];

  const handleUploaded = () => {
    setActiveTab(TEMPLATE_TAB);
    refetchTemplates().catch(() => {});
  };

  const handleEdit = (template) => {
    const clientId = getClientId();
    const caseId = getCaseId();
    const templateId = template?.id;

    if (!clientId || !caseId || !templateId) return;

    const editorUrl = `/esign/${encodeURIComponent(clientId)}/${encodeURIComponent(
      caseId
    )}/template/${encodeURIComponent(templateId)}`;
    window.open(editorUrl, "_blank", "noopener,noreferrer");
  };

  const hintPoints = [
    "View the E-Signature templates available to your firm.",
    "Upload a PDF template for a selected case type.",
    "Use Edit to open the template in the E-Signature editor.",
  ];

  return (
    <>
      <div className="tab-pane fade active show esign-settings">
        <div
          className="d-flex justify-content-between m-b-5"
          style={{ position: "absolute", right: "0px" }}
        >
          <div>
            <h3 style={{ fontSize: "24px" }} />
          </div>
          {/* <div onClick={() => setShowHints(true)}>
            <i className="ic ic-19 ic-help-2 cursor-pointer" />
          </div> */}
        </div>

        <div className="overflow-auto" style={{ width: "100%" }}>
          <NavFirmTemplateSettingsTab sidebarItems={sidebarItems} activeTab={activeTab} />
        </div>

        <div className="tab-content uploadstackedsettingsnavtab">
          {activeTab === TEMPLATE_TAB ? (
            <ESignatureTemplates
              templates={templates}
              loading={templatesLoading}
              error={templatesError}
              onRetry={() => refetchTemplates().catch(() => {})}
              onEdit={handleEdit}
            />
          ) : (
            <UploadESignatureTemplate
              caseTypesByCategory={caseTypesByCategory}
              caseTypesLoading={caseTypesLoading}
              caseTypesError={caseTypesError}
              onRetryCaseTypes={() => refetchCaseTypes().catch(() => {})}
              onUploaded={handleUploaded}
            />
          )}
        </div>
      </div>

      {showHints && (
        <HintModal show={showHints} handleClose={() => setShowHints(false)} points={hintPoints} />
      )}
    </>
  );
};

export default ESignature;
